
import * as React from 'react';
import * as ReactDOM from 'react-dom';
// import './polyfills.ts'; TODO check required browser support
// import registerServiceWorker from './registerServiceWorker';
//import 'semantic-ui-less/semantic.less';
import './stylesheets/Lato/latofonts.css';
import './stylesheets/semantic.min.css';
import './index.css';
import {HashRouter} from 'react-router-dom';
import AppContainer from './modules/App/AppContainer/AppContainer';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import './i18n';

ReactDOM.render(
    <HashRouter>
        <AppContainer/>
        <ToastContainer/>
    </HashRouter>,
    document.getElementById('root') as HTMLElement
);
// registerServiceWorker();
